module.exports = __webpack_public_path__ + "img/seo_gfish_item04.10cfe75.webp";